
import { map } from 'ramda';
import Joi from 'joi-full';
import { COUNTRY_NAME_BY_CODE } from '../../main/shops/constants';

const usaSchema = {
  address: Joi.object().keys({
    street: Joi.string().required(),
    street2: Joi.string().optional().allow('', null),
    city: Joi.string().min(3).label('City').required(),
    state: Joi.string().length(2).label('State').required(),
    zip: Joi.string().min(3).label('Zip Code').required(),
    country: Joi.string().required(),
  }),
};

const caSchema = {
  address: Joi.object().keys({
    street: Joi.string().required(),
    street2: Joi.string().optional().allow('', null),
    city: Joi.string().min(3).label('Municipality').required(),
    state: Joi.string().length(2).label('Province').required(),
    zip: Joi.string().min(3).label('Postal Code').required(),
    country: Joi.string().required(),
  }),
};

const gbSchema = {
  address: Joi.object().keys({
    street: Joi.string().required(),
    street2: Joi.string().optional().allow('', null),
    city: Joi.string().min(3).label('Post Town').required(),
    state: Joi.string().min(3).label('County').required(),
    zip: Joi.string().min(3).label('Postcode').required(),
    country: Joi.string().required(),
  }),
};

const ieSchema = {
  address: Joi.object().keys({
    street: Joi.string().required(),
    street2: Joi.string().optional().allow('', null),
    city: Joi.string().min(3).label('City or Town').required(),
    state: Joi.string().min(3).label('County').required(),
    zip: Joi.string().min(3).label('Eircode').required(),
    country: Joi.string().required(),
  }),
};

const auSchema = {
  address: Joi.object().keys({
    street: Joi.string().required(),
    street2: Joi.string().optional().allow('', null),
    city: Joi.string().min(3).label('City or Town or Locality').required(),
    state: Joi.string().min(2).max(3).label('State or Territory')
      .required(),
    zip: Joi.string().min(3).label('Postcode').required(),
    country: Joi.string().required(),
  }),
};

const addressSchemaByCountry = {
  [COUNTRY_NAME_BY_CODE.US]: usaSchema,
  [COUNTRY_NAME_BY_CODE.CA]: caSchema,
  [COUNTRY_NAME_BY_CODE.GB]: gbSchema,
  [COUNTRY_NAME_BY_CODE.IE]: ieSchema,
  [COUNTRY_NAME_BY_CODE.AU]: auSchema,
};

const prepareSchemasByCountry = baseSchema => map(
  addressSchema => Joi.object().keys({
    ...baseSchema,
    ...addressSchema,
  }),
  addressSchemaByCountry
);


export {
  addressSchemaByCountry,
  prepareSchemasByCountry,
};
